module.exports = __webpack_public_path__ + "img/img14.27ef6bc6.jpg";